export const MEMBER_ROLES_VALUES = {
  owner: 'owner',
  admin: 'admin',
  editor: 'editor',
  viewer: 'viewer',
} as const;

export type MemberRole =
  (typeof MEMBER_ROLES_VALUES)[keyof typeof MEMBER_ROLES_VALUES];

export const MEMBER_ROLES_LABELS: Record<MemberRole, string> = {
  owner: 'Owner',
  admin: 'Admin',
  editor: 'Editor',
  viewer: 'Viewer',
};

export const MEMBER_ROLES_LABELS_NO_OWNER = Object.fromEntries(
  Object.entries(MEMBER_ROLES_LABELS).filter(([key]) => key !== 'owner'),
) as Record<Exclude<MemberRole, 'owner'>, string>;
